module.exports = __webpack_public_path__ + "static/media/account_image.5415ba3f.jpg";